/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_Current_TitleInputs */

const en_admin_footer_badges_current_title = /** @type {(inputs: Admin_Footer_Badges_Current_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible badges`)
};

/**
* | output |
* | --- |
* | "Visible badges" |
*
* @param {Admin_Footer_Badges_Current_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_current_title = /** @type {((inputs?: Admin_Footer_Badges_Current_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Current_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_current_title(inputs)
});
export { admin_footer_badges_current_title as "admin.footer_badges.current_title" }